import { ChartValue } from "../types";
import { SOD } from "../common/constants";

export function mapToChartValues(values: any): ChartValue[] {
  return values
    ? Object.entries(values).map(function ([slice, value]) {
        if (slice === "1") {
          return { slice: SOD, value: value as string };
        } else {
          return { slice: slice, value: value as string };
        }
      })
    : [];
}
